var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91898 3.13916C7.2955 3.55506 5.83289 4.44559 4.71808 5.69694C3.60327 6.94829 2.8869 8.50362 2.6605 10.1642C2.43411 11.8247 2.70798 13.5151 3.44712 15.0192C4.18625 16.5233 5.35708 17.7728 6.80998 18.6082V22.5462",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51295 11.297C7.50508 11.7636 7.5902 12.2272 7.76333 12.6606C7.93647 13.094 8.19416 13.4886 8.52139 13.8214C8.84861 14.1542 9.23882 14.4185 9.66925 14.5989C10.0997 14.7793 10.5617 14.8723 11.0285 14.8723C11.4952 14.8723 11.9572 14.7793 12.3877 14.5989C12.8181 14.4185 13.2083 14.1542 13.5355 13.8214C13.8627 13.4886 14.1204 13.094 14.2936 12.6606C14.4667 12.2272 14.5518 11.7636 14.544 11.297C14.5518 10.8303 14.4667 10.3668 14.2936 9.93336C14.1204 9.49994 13.8627 9.10534 13.5355 8.77254C13.2083 8.43975 12.8181 8.17544 12.3877 7.99502C11.9572 7.8146 11.4952 7.72168 11.0285 7.72168C10.5617 7.72168 10.0997 7.8146 9.66925 7.99502C9.23882 8.17544 8.84861 8.43975 8.52139 8.77254C8.19416 9.10534 7.93647 9.49994 7.76333 9.93336C7.5902 10.3668 7.50508 10.8303 7.51295 11.297Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1379 8.48413V2.15613C13.1379 1.96968 13.0639 1.79087 12.932 1.65903C12.8002 1.52719 12.6214 1.45312 12.4349 1.45312H9.62195C9.4355 1.45313 9.25669 1.52719 9.12485 1.65903C8.99301 1.79087 8.91895 1.96968 8.91895 2.15613V8.48413",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2479 22.5471V20.4471L16.1909 20.6051C16.5939 20.6724 17.0066 20.651 17.4005 20.5426C17.7944 20.4342 18.1599 20.2413 18.4717 19.9773C18.7835 19.7133 19.034 19.3845 19.2059 19.0139C19.3777 18.6433 19.4668 18.2397 19.4669 17.8311V15.5251L20.3439 15.3071C20.5627 15.2526 20.7651 15.1462 20.9341 14.997C21.1031 14.8478 21.2338 14.6601 21.3151 14.4498C21.3964 14.2395 21.4259 14.0127 21.4011 13.7886C21.3764 13.5645 21.2981 13.3496 21.1729 13.1621L19.4679 10.6041V9.90113C19.4679 6.58113 16.7789 3.79813 13.1399 3.05713",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.a6dea88878f3163a533da6d73b63b106.svg";
export { ForwardRef as ReactComponent };